export default "__VITE_ASSET__3e278ac7__"